import { getWindow } from '../services/window';
import { oldToNewUrlKeys } from './constants';
export const isOneTaxonomyEnabled = ()=>{
    var _process, _getWindow___INITIAL_STATE___config, _getWindow___INITIAL_STATE__, _getWindow;
    return ((_process = process) === null || _process === void 0 ? void 0 : _process.env.enableOneTaxonomy) === 'true' || ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config = _getWindow___INITIAL_STATE__.config) === null || _getWindow___INITIAL_STATE___config === void 0 ? void 0 : _getWindow___INITIAL_STATE___config.enableOneTaxonomy);
};
export const newToOldUrlKeys = Object.fromEntries(Object.entries(oldToNewUrlKeys).map(([newKey, oldKey])=>[
        oldKey,
        newKey
    ]));
